import leagueRules from './League';
import compRules from './Comps';
import userRules from './User';
import contactRules from './ContactUs';

export {
	leagueRules,
	compRules,
	userRules,
	contactRules
};

export default {
	leagueRules,
	compRules,
	userRules,
	contactRules
};